import { Fragment, useEffect, useState } from "react";
import { clientAccountBasePath, dashboardPath } from "./routePaths";
import { getAccessTypes } from "../hooksAndFunctions/functions/getAccessTypes";
import { Outlet } from "react-router-dom";
import AccessDeniedComp from "./AccessDeniedComp";

const ProtectedClientPortalSettingRoutes = () => {

    const accesses = getAccessTypes()

    const { isEnterpriseAdmin,
        clientPortalAdminType,
    } = accesses;

    const {
        isClientPortalAdmin,
    } = clientPortalAdminType

    const [allowAccess, setAllowAccess] = useState(false)
    useEffect(() => {
        if (!!isEnterpriseAdmin) {
            setAllowAccess(true)
        } else {
            if (!!isClientPortalAdmin) {
                setAllowAccess(true)
            } else {
                setAllowAccess(false)
            }
        }
    }, [accesses])

    return (
        <Fragment>
            {
                !!allowAccess ? <Outlet /> : <AccessDeniedComp />
            }
        </Fragment>
    )
}

export default ProtectedClientPortalSettingRoutes;